import React, { forwardRef, useCallback, useEffect } from 'react';
import { VariableSizeList as List } from 'react-window';
import ListItem from '../LayoutItems/ListItem';
import { findSectionForRow, warnOnNoSection, normalizeIndex } from '../shared';
import withMemoizedLayout from './withMemoizedLayout';
import useSetLayoutRef from './useSetLayoutRef';

export const getListItemKey = (index, data, sections) => {
  const section = findSectionForRow(sections, index);

  let key;

  if (!section) {
    warnOnNoSection(index, 'list');
  }

  if (section && section.itemKey) {
    const relIndex = normalizeIndex(index, section);
    key = section.itemKey(relIndex, { ...data.data, ...section.itemProps });
  }

  return key || `row:${index}`;
};

export const ListLayout = forwardRef((props, ref) => {
  const { rows, sections, ...listProps } = props;

  const { layout, setLayoutRef } = useSetLayoutRef(ref);

  const getItemSize = useCallback(
    (index) => {
      const section = findSectionForRow(sections, index);
      return section ? section.itemHeight : 0;
    },
    [sections]
  );

  const getItemKey = useCallback(
    (index, data) => {
      return getListItemKey(index, data, sections);
    },
    [sections]
  );

  useEffect(() => {
    if (layout) {
      layout.resetAfterIndex(0);
    }
  });

  return (
    <List
      {...listProps}
      ref={setLayoutRef}
      itemSize={getItemSize}
      itemCount={rows}
      itemKey={getItemKey}
      itemData={{
        sections,
        rows,
      }}
    >
      {ListItem}
    </List>
  );
});

export default withMemoizedLayout(ListLayout);
